var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEdit(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#595959"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1268.7 39c-.386 0-.7-.322-.7-.719l.056-2.407c0-.397.314-.72.7-.72.388 0 .702.323.702.72v.862l2.151-1.782-2.158-1.172c-.683-.372-.943-1.24-.582-1.94l4.261-8.258c.456-.93 1.367-1.535 2.382-1.581 1.014-.046 1.973.474 2.507 1.36.534.886.56 1.998.066 2.909l-3.28 6.353c-.118.227-.345.373-.595.382-.251.009-.487-.12-.62-.338-.134-.218-.143-.492-.025-.72l3.28-6.353c.361-.703.1-1.573-.586-1.944-.685-.371-1.534-.103-1.895.6l-4.276 8.28 2.159 1.171c.415.226.692.651.737 1.131.045.48-.147.952-.513 1.255l-3.329 2.753c-.125.103-.28.159-.441.158zm15.3-.719c0-.397-.314-.718-.7-.718h-10.513c-.387 0-.701.321-.701.718 0 .397.314.719.7.719h10.513c.387 0 .701-.322.701-.719z",
    transform: "translate(-1364 -124) translate(96 102)"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.aaf4888c.svg";
export { ForwardRef as ReactComponent };